import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton"; // Assuming you're using Material Dashboard components

// eslint-disable-next-line react/prop-types
function ConvertPiComponent({ id, onConvertPi }) {
  const [open, setOpen] = useState(false);
  const [expectedDate, setExpectedDate] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    if (expectedDate) {
      onConvertPi(id, expectedDate);
      setExpectedDate("");
      handleClose();
    }
  };

  return (
    <>
      <MDTypography
        pl={2}
        component="a"
        href="#"
        variant="caption"
        color="text"
        fontWeight="medium"
        onClick={(e) => {
          e.preventDefault();
          handleOpen();
        }}
      >
        Convert PI
      </MDTypography>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Enter Expected Delivery Date</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Expected Delivery Date"
            type="date"
            fullWidth
            value={expectedDate}
            onChange={(e) => setExpectedDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose}>Cancel</MDButton>
          <MDButton onClick={handleConfirm} variant="gradient" color="info">
            Confirm
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConvertPiComponent;
